
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CategoryMasterDialog extends Serenity.EntityDialog<CategoryMasterRow, any> {
        protected getFormKey() { return CategoryMasterForm.formKey; }
        protected getIdProperty() { return CategoryMasterRow.idProperty; }
        protected getLocalTextPrefix() { return CategoryMasterRow.localTextPrefix; }
        protected getNameProperty() { return CategoryMasterRow.nameProperty; }
        protected getService() { return CategoryMasterService.baseUrl; }
        protected getInsertPermission() { return CategoryMasterRow.insertPermission; }
        protected getUpdatePermission() { return CategoryMasterRow.updatePermission; }
        protected getDeletePermission() { return CategoryMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        protected form = new CategoryMasterForm(this.idPrefix);

        constructor() {
            super();
            this.form.CategoryCode.changeSelect2(e => {
                var id = CategoryMasterRow.getLookup().items.filter(x => x.CategoryCode.toUpperCase() == this.form.CategoryCode.value.toUpperCase())[0];
                if (id != undefined) {
                    if (id.CategoryId != null || id.CategoryId > 0) {
                        Q.notifyError("Duplicate Category " + this.form.CategoryCode.value);
                        this.form.CategoryCode.value = "";
                        return;

                    }
                }
                else {
                    this.form.CategoryCode.value = this.form.CategoryCode.value.toUpperCase()
                }
            })
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            return btns;
        }

        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            var refid = SubCategoryDetailsRow.getLookup().items.filter(x => x.CategoryId == this.entityId)[0];

            if (refid != null) {
                if (refid.CategoryId != null || refid.CategoryId > 0) {
                    Q.alert("Category is in Use, Delete not permitted");
                    return;

                }
            } else {
                CategoryMasterService.Delete(
                    {
                        EntityId: this.entityId
                    },
                    response =>
                    {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    }
                );
            }

        }

    }
}